import { Flex, Paper, TertiarySmall, Link } from "@base-ui";
import { SingleColumnPage } from "@templates/pageLayouts";
import Image from "@cms/components/ui/Image";
import IconQuote from "@cms/components/ui/IconQuote";
import fallbackImg from "assets/ux/vis_start_fallback.jpg";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function MissingPage() {
  var infographicContent = {
    id: "missing-page-iconquote",
    src: "stroke",
    alt: "Ikon föreställande saknat innehåll",
    formattedText: JSON.stringify({
      ops: [{
        insert: "Sidan hittades inte."
      }, {
        insert: "\n"
      }, {
        insert: "Det kan bero på stavfel, att sidan inte längre finns eller att den har flyttats."
      }]
    })
  };
  return /*#__PURE__*/_jsx(SingleColumnPage, {
    children: /*#__PURE__*/_jsxs(Flex.Column, {
      mb: "-20px",
      position: "relative",
      children: [/*#__PURE__*/_jsx(Image, {
        id: "missing-page",
        src: fallbackImg,
        alt: "",
        minHeight: "600px",
        maxHeight: "calc(100vh - 300px)",
        opacity: ".4"
      }), /*#__PURE__*/_jsx("div", {
        style: {
          position: "absolute",
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          display: "flex"
        },
        children: /*#__PURE__*/_jsxs(Paper.Column, {
          p: "md",
          width: "fit-content",
          margin: "auto",
          maxWidth: "450px",
          children: [/*#__PURE__*/_jsx(TertiarySmall, {
            m: "0 auto 20px",
            children: "404: Page not found"
          }), /*#__PURE__*/_jsx(IconQuote, {
            iconQuote: infographicContent,
            p: "0"
          }), /*#__PURE__*/_jsxs(Flex.Column, {
            mp: "10px",
            alignItems: "center",
            children: [/*#__PURE__*/_jsx(Link, {
              to: "/",
              children: "G\xE5 tillbaka till startsidan"
            }), /*#__PURE__*/_jsx(Link, {
              to: "",
              as: "a",
              target: "_blank",
              rel: "noreferrer",
              width: "fit-content",
              href: "https://skr.se/skr/halsasjukvard/kunskapsstodvardochbehandling/tillganglighetivardenvardgarantin/vardenisiffror/kontaktavardenisiffror.47008.html",
              children: "Kontakta oss"
            })]
          })]
        })
      })]
    })
  });
}